/**
 * @description
 * @author: 菩萨蛮
 * @date 2020/9/8 10:11 上午
 * @version V1.0.0
 *
 * 公司的业务千篇一律，复杂的代码好几百行
 */

const checkOrder = {
  created() {
    this.setDefaultValue();
  }
};

export default checkOrder;
